import IndexedDBManager from "../services/indexdb.service";
import { DraftType } from "../types/drafts";


class AutoSaveModel {
    dbManager: null | IndexedDBManager = null;

    constructor() {
        this.dbManager = new IndexedDBManager("monclova.autosave");
    }

    public async openDb(): Promise<void> {
        if(!this.dbManager) return;
        await this.dbManager.open();
    }

    public async createDraft(): Promise<number> {
        if(!this.dbManager) return -1;

        const generatedId = await this.dbManager.addItem({
            createdAt: new Date().toISOString(),
        })

        return generatedId;
    }

    public async updateDraft(id: number, data: string | undefined | null) {
        if(!this.dbManager || !data) return;

        const found = await this.dbManager.getItem(id);
        if(!found) {
            await this.dbManager.addItem({
                id,
                item: data,
                updatedAt: new Date().toISOString(),
                createdAt: new Date().toISOString(),
            })
            return;
        }

        await this.dbManager.updateItem(id, data);
    }

    public async getDraft(id: number) : Promise<DraftType | undefined>  {
        if(!this.dbManager) return undefined;
        const item = await this.dbManager.getItem(id);
        return item;
    }

    public async getDrafts() : Promise<Array<DraftType>>  {
        if(!this.dbManager) return [];
        const items = await this.dbManager.getAllItems();
        return items;
    }

    public async deleteDraft(id: number) {
        if(!this.dbManager) return;
        await this.dbManager.deleteItem(id);
    }

    public async clearDrafts() {
        if(!this.dbManager) return;
        await this.dbManager.clearStore();
    }
}
export default AutoSaveModel;